import { applyI18n, t } from '../i18n';
import { parseCertificate } from '../files/certParse';

export async function renderCertificatePreview(
  content: HTMLElement,
  blob: Blob,
  fileName: string,
): Promise<boolean> {
  try {
    const bytes = new Uint8Array(await blob.arrayBuffer());
    const cert = parseCertificate(bytes, fileName);
    renderCertificate(content, cert);
    return true;
  } catch {
    return false;
  }
}

function renderCertificate(
  content: HTMLElement,
  cert: ReturnType<typeof parseCertificate>,
): void {
  const wrap = document.createElement('div');
  wrap.className = 'file-preview-certificate';

  const fields = document.createElement('dl');
  fields.className = 'file-preview-certificate-fields';
  for (const field of cert.fields) {
    const dt = document.createElement('dt');
    dt.textContent = t(`files.preview.certificate.${field.label}`, { defaultValue: field.label });
    const dd = document.createElement('dd');
    dd.textContent = field.value;
    fields.append(dt, dd);
  }

  wrap.append(fields);
  content.append(wrap);
  applyI18n(wrap);
}
